import { useRef, useState } from 'react';
import { useOnClickOutside } from '../../../../hooks';
import { UpTick } from '../../../Icons';
import useOnHoverOutside from '../../../hooks/use-hover-outside';
import { TDROPDOWN_PROPS, TNAV_LINK_STRUCTURE } from '../types';
import { handleTrack } from '../../../../utils/tracker';

interface TDropdown {
  dropdownLabel: string;
  dropdownList: TNAV_LINK_STRUCTURE[];
  Dropdown: ({
    activeState,
    dropdownList,
    topMenu,
  }: TDROPDOWN_PROPS) => JSX.Element;
  classes?: string;
  dropdownDefaultState?: boolean;
  logoutFunction?: () => void;
  hover?: boolean;
  language?: string;
  domain?: string;
  openSidebar?: () => void;
  topMenu?: boolean;
}

const DropdownComponent = ({
  dropdownLabel,
  Dropdown,
  classes,
  logoutFunction,
  dropdownDefaultState = false,
  dropdownList,
  language = 'English',
  domain = 'in',
  hover = false,
  openSidebar,
  topMenu = false,
}: TDropdown): JSX.Element => {
  const [dropdownState, setDropdownState] = useState(dropdownDefaultState);

  const ref = useRef(null);

  const toggleFunction = () => {
    setDropdownState(!dropdownState);
    openSidebar && openSidebar();
  };

  useOnClickOutside(ref, () => {
    setDropdownState(false);
  });
  useOnHoverOutside(ref, () => {
    setDropdownState(false);
  });
  const setDropdownStateTrue = () => {
    setDropdownState(true);
  };

  return (
    <div ref={ref} className={classes}>
      <button
        type="button"
        className={
          'font-medium inline-flex w-auto py-2 rounded text-font-500 transition duration-150 ease-in-out whitespace-nowrap items-center justify-start sm:w-full sm:justify-between focus:outline-none' +
          (domain === 'sa' ? ' text-s-14' : '')
        }
        id="menu-button"
        aria-expanded="true"
        aria-haspopup="true"
        onClick={(e) => {
          handleTrack({
            label: 'navbar_cta',
            obj: e.target,
          });
          toggleFunction();
        }}
        {...(hover ? { onMouseEnter: setDropdownStateTrue } : {})}
      >
        {dropdownLabel}
        <span className={`${dropdownState ? 'rotate-180' : ''} px-2`}>
          <UpTick colorCode="#596C85" />
        </span>
      </button>
      <Dropdown
        activeState={dropdownState}
        logoutFunction={logoutFunction}
        dropdownList={dropdownList}
        language={language}
        topMenu={topMenu}
      />
    </div>
  );
};

export { DropdownComponent };
